import FanPassUnlock from './fan-pass-unlock'

export * from './fan-pass-unlock'

FanPassUnlock.define('fp-unlock')

declare global {
  interface HTMLElementTagNameMap {
    'fp-unlock': FanPassUnlock;
  }
}
  
export default FanPassUnlock